import { Component, Input, OnInit } from '@angular/core';
import { AudioService } from '../../../core/services/audio.service';
import { StreamState } from '../../../core/models';
import { Podcast } from 'src/app/core/models';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../core/store/app.state';
import * as PodcastActions from '../../../core/store/podcast/podcast.actions';
import { selectAllPodcasts } from '../../../core/store/podcast/podcast.selectors';

@Component({
  selector: 'app-podcast-list',
  templateUrl: './podcast-list.component.html',
  styleUrls: ['./podcast-list.component.scss'],
})
export class PodcastListComponent implements OnInit {
  @Input() platform: number;
  podcasts$: Observable<Podcast[]>;
  page = 1;
  limit = 50;

  state: StreamState;
  constructor(
    public audioService: AudioService,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.store.dispatch(
      PodcastActions.loadPodcasts({ page: this.page, limit: this.limit })
    );
    this.podcasts$ = this.store.pipe(select(selectAllPodcasts));

    this.audioService.getState().subscribe(state => {
      this.state = state;
    });
  }

  pause() {
    this.audioService.pause();
  }

  play() {
    this.audioService.play();
  }

  stop() {
    this.audioService.stop();
  }

  playStream(url: string) {
    this.audioService.playStream(url).subscribe(events => {
      // listening for fun here
    });
  }

  playPodcast(podcast: Podcast) {
    this.audioService.playPodcast(podcast).subscribe(events => {
      // listening for fun here
    });
  }

  playPodcasts(podcasts: Podcast[]) {
    this.audioService.appendPlaylist(podcasts);
    if (!this.state.playing) {
      this.audioService.playCurrentPlaylist().subscribe(events => {
        // listening for fun here
      });
    }
  }

  playAll() {
    if (this.state.playing) {
      this.audioService.pause();
    } else if (this.state.paused) {
      this.audioService.play();
    } else {
      this.store
        .pipe(select(selectAllPodcasts))
        .subscribe((podcasts: Podcast[]) => {
          this.playPodcasts(podcasts);
        });
    }
  }

  scrolledPodcast($event: number) {
    if ($event / this.limit / this.page > 0.75) {
      this.page = this.page + 1;
      this.store.dispatch(
        PodcastActions.loadPodcasts({ page: this.page, limit: this.limit })
      );
    }
  }
}
